import { URLS } from 'rebook/apps/base/constants';


export default
[
  {
    key: 0,
    url: URLS.accountSettings,
    text: 'Настройки',
  },
  {
    key: 1,
    url: URLS.accountPaymentList,
    text: 'История покупок',
  },
  {
    key: 2,
    url: URLS.activateGift,
    text: 'Подарочный код',
  },
];
